import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["IconList"] || "IconList"} xmlns="http://www.w3.org/2000/svg" width="13" height="18" {...props}><g fill="#6D7075" fillRule="evenodd"><rect width="13" height="1.3" y="3.7" rx=".65" /><rect width="13" height="1.3" y="8.7" rx=".65" /><rect width="13" height="1.3" y="13.7" rx=".65" /></g></svg>);